export const computeBaseline = (points: number[]) => {
  if (points.length === 0) return { mean: 0, stddev: 0 }
  const mean = points.reduce((sum, point) => sum + point, 0) / points.length
  const stddev = points.length < 2 ? 0 : Math.sqrt(points.reduce((sum, point) => sum + (point - mean) ** 2, 0) / points.length)
  return { mean, stddev }
}
export const computeZScore = (value: number, points: number[]) => { const { mean, stddev } = computeBaseline(points); return stddev === 0 ? 0 : (value - mean) / stddev }
